import { ButtonGroup } from '../../../../../components'
import { GroupByTime } from '@indigohive/cogfy-types'
import { useTranslation } from 'react-i18next'

export type headerComponentProps = {
  groupBy: GroupByTime
  setGroupBy: (groupBy: GroupByTime) => void
}

export function HeaderComponent (props: headerComponentProps) {
  const { groupBy, setGroupBy } = props

  const { t } = useTranslation()
  return (
    <div className='flex flex-row w-full justify-end items-end gap-4'>
      <ButtonGroup
        title={t('workspaceUsagePage:Group by')}
        options={[
          { label: t('workspaceUsagePage:Hour'), value: 'hour' },
          { label: t('workspaceUsagePage:Day'), value: 'day' },
          { label: t('workspaceUsagePage:Month'), value: 'month' },
          { label: t('workspaceUsagePage:Year'), value: 'year' }
        ]}
        value={groupBy}
        onButtonClick={value => setGroupBy(value as GroupByTime)}
      />
    </div>
  )
}
